import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DialogRoundedModal from '../../../components/DialogRoundedModal';
import { SaveButton, CancelButton } from '../../../components/Button/ActionButtons';
import { productLabel } from '../../utils/billingTarget';
import RadioButtonGroup from '../RadioButtonGroup';

import { OptionsContainer } from './styles';
import texts from './texts.json';

const ContractChooserModal = ({
  title,
  description,
  candidates,
  onConfirm,
  onCancel,
}) => {
  const [selectedContractId, setSelectedContractId] = useState(candidates[0]?.contractId || '');

  return (
    <DialogRoundedModal
      open
      onClose={onCancel}
      title={title}
      description={description}
      actionButtons={(
        <>
          <SaveButton
            disabled={!selectedContractId}
            onClick={() => onConfirm(selectedContractId)}
          >
            {texts.confirm}
          </SaveButton>
          <CancelButton onClick={onCancel}>
            {texts.cancel}
          </CancelButton>
        </>
      )}
    >
      <OptionsContainer>
        <RadioButtonGroup
          options={candidates.map((candidate) => ({
            value: candidate.contractId,
            label: productLabel(candidate),
          }))}
          selectedOption={selectedContractId}
          onOptionChange={setSelectedContractId}
        />
      </OptionsContainer>
    </DialogRoundedModal>
  );
};

ContractChooserModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  candidates: PropTypes.arrayOf(PropTypes.object).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ContractChooserModal.defaultProps = {
  description: '',
};

export default ContractChooserModal;
